/*
 * @Description: Description
 * @Autor: Chen
 * @Date: 2020-05-20 14:13:56
 * @LastEditors: snzo.chen
 * @LastEditTime: 2021-12-28 16:23:13
 */
import { Injectable } from '@angular/core';
import {
  CanActivate, CanActivateChild, CanDeactivate,
  CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storage.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanDeactivate<unknown>, CanLoad {
  constructor(
    private authServe: AuthService,
    private router: Router,
    private storageServe: StorageService,
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const url: string = state.url;
    return this.checkLogin(url);
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }


  checkLogin(url: string): boolean {
    this.authServe.redirectUrl = url;
    const isLoggedIn = this.storageServe.getStorage('isLoggedIn');
    const token = this.storageServe.getStorage('token');
    if (isLoggedIn) {
      this.authServe.isLoggedIn = true;
      this.authServe.operator = isLoggedIn;
      this.authServe.token = token;
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}
